module.exports = __webpack_public_path__ + "static/logo-80b027b691267c1183e4550281448f4f.gif";